import React, { useState } from 'react';

import './style.scss';

const initialState = new Date().getUTCFullYear();

const Bottom = ({ className }) => {
  const [year] = useState(initialState);

  return (
    <footer className={`footer ${className || ''}`}>
      <p>&copy; {year > 2022 ? `2022 - ${year}` : year}</p>
    </footer>
  );
};

export default Bottom;
